export function initTabs(containerSelector: string) {
    const container = document.querySelector<HTMLElement>(containerSelector);
    if (!container) return;

    const tabs = container.querySelectorAll<HTMLButtonElement>('.tab-btn');
    const panels = container.querySelectorAll<HTMLElement>('.tab-panel');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = tab.dataset.tab;
            if (!target) return;

            // Убираем активный класс у всех табов
            tabs.forEach(t => t.classList.remove('active'));
            // Делаем текущий таб активным
            tab.classList.add('active');

            // Скрываем все панели
            panels.forEach(panel => panel.classList.remove('active'));
            // Показываем панель с нужным data-tab-panel
            const activePanel = container.querySelector<HTMLElement>(`.tab-panel[data-tab-panel="${target}"]`);
            if (activePanel) activePanel.classList.add('active');
        });
    });
}
